export default "__VITE_ASSET__Bed7BnZp__"